module.exports = __webpack_public_path__ + "media/beer-movie.4a81c587.mp4";